import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, Image, Stack, Text, Textarea, TextInput } from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { useForm } from "@mantine/form";
import { getInputStyles, getTextareaStyles } from "../reservation/reservation.helper";
import { sendEmail } from "../../../redux/reducers/publicSlice";
import { selectEmailLoading, selectFooterContent } from "../../../redux/selectors/publicSelector";
import colors from "../../../utils/styles";

const BannerSection = () => {
    const dispatch = useDispatch();

    const [opened, { close }] = useDisclosure(true);
    const [dialogSection, setDialogSection] = useState<"banner" | "contact">("banner");
    const emailLoading = useSelector(selectEmailLoading);
    const footer = useSelector(selectFooterContent);
    const isMobile = useMediaQuery('(max-width: 768px)');

    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            message: ''
        },
        validate: {
            name: (value) => value.length > 0 ? null : 'Name is required',
            email: (value) => value.length > 0 ? null : 'Email is required',
            message: (value) => value.length > 0 ? null : 'Message is required',
        }
    });

    const handleSendEmail = () => {
        dispatch(sendEmail({...form.values as any, subject: 'Group Summer Deals!'}));
        setTimeout(() => {
            close();
        }, 1000);
    };

    if (dialogSection === "banner") {
        return <Image
            onClick={() => setDialogSection("contact")}
            style={{
                position: 'fixed',
                top: '20vh',
                left: '5vw',
                zIndex: 1000,
                cursor: 'pointer'
            }}
            p={0}
            m={0}
            w={isMobile ? 180 : 250}
            h={isMobile ? 180 : 250}
            src="/assets/images/group_family_banner.png"
            alt="divider" />
    }

    return (
        <Dialog
            style={{
                width: isMobile ? '80vw' : 350,
                textAlign: "center",
                backgroundColor: colors.appLightBlue,
                border: `1px solid ${colors.appYellow}`
            }}
            position={!isMobile ? { bottom: '1vh', left: '1vw' } : { bottom: 120, right: '10vw' }}
            radius={10}
            c={colors.appYellow}
            opened={opened}
            withCloseButton
            onClose={close}>
            <Stack align="center" justify="center" gap={0} style={{ marginTop: -10, marginBottom: -5, marginLeft: -5, marginRight: -5 }}>
                <Text size="md" fw={700} m={0} p={0}>
                    Group Summer Deals!
                </Text>
                <Text size="sm" fw={500} m={0} p={0}>
                    Planning a trip with friends or family?<br />
                    Unlock exclusive seasonal discounts for groups & families!<br />
                    Email us or <Text component="a" href={`tel:${footer.contact.phone.mobile}`} style={{ color: 'inherit', textDecoration: 'underline' }}>message us on WhatsApp</Text> now —
                    Let the Greek celebration begin!<br />
                    • Limited-time offers <br />
                    • Perfect for wedding parties & summer reunions <br />
                    • Personalized group packages <br />
                    Don’t miss out — your Santorini story starts here!
                </Text>
                <TextInput
                    mt={10}
                    label="Name"
                    styles={getInputStyles(form.errors.name) as any}
                    style={{ marginLeft: "auto", marginRight: "auto", width: "80%" }}
                    placeholder="Your name"
                    {...form.getInputProps('name')}
                    variant="unstyled"
                    radius={0}
                />
                <TextInput
                    label="Email"
                    styles={getInputStyles(form.errors.email) as any}
                    style={{ marginLeft: "auto", marginRight: "auto", width: "80%" }}
                    placeholder="Your email"
                    {...form.getInputProps('email')}
                    variant="unstyled"
                    radius={0}
                />
                <Textarea
                    label="Message"
                    styles={getTextareaStyles(form.errors.message, 84) as any}
                    style={{ marginLeft: "auto", marginRight: "auto", width: "80%" }}
                    placeholder="Your message"
                    {...form.getInputProps('message')}
                    variant="unstyled"
                    radius={0}
                />
                <Button disabled={emailLoading || !form.isValid()} style={{ backgroundColor: colors.appPink }} mt={4} onClick={handleSendEmail} loading={emailLoading}>
                    Send Email
                </Button>
            </Stack>

        </Dialog >
    )
}

export default BannerSection;